import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';
import {
	COMPANY_PROFILE_INVITATION_FRAGMENT,
} from '@app/model/company_profile_invitation/service/CompanyProfileInvitationGraphQLFragments';


export const FIND_COMPANY_PROFILE_INVITATION_QUERY: GraphQL = {
    name: 'findCompanyProfileInvitation',
    gql: gql`
        ${COMPANY_PROFILE_INVITATION_FRAGMENT}
        query findCompanyProfileInvitation($profileId: Long!) {
            findCompanyProfileInvitation(profileId: $profileId) {
                ...CompanyProfileInvitationFields
            }
        }
    `
}

export const FIND_ACTIVE_COMPANY_PROFILE_INVITATION_BY_KEY_QUERY: GraphQL = {
    name: 'findActiveCompanyProfileInvitationByKey',
    gql: gql`
        query findActiveCompanyProfileInvitationByKey($key: String!) {
            findActiveCompanyProfileInvitationByKey(key: $key) {
                key
                email
            }
        }
    `
}

export const CREATE_COMPANY_PROFILE_INVITATION_MUTATION: GraphQL = {
    name: 'createCompanyProfileInvitation',
    gql: gql`
        ${COMPANY_PROFILE_INVITATION_FRAGMENT}
        mutation createCompanyProfileInvitation($input: CreateCompanyProfileInvitationInput!) {
            createCompanyProfileInvitation(input: $input) {
                ...CompanyProfileInvitationFields
            }
        }
    `
}

export const ACCEPT_COMPANY_PROFILE_INVITATION_MUTATION: GraphQL = {
    name: 'acceptCompanyProfileInvitation',
    gql: gql`
        ${COMPANY_PROFILE_INVITATION_FRAGMENT}
        mutation acceptCompanyProfileInvitation($input: AcceptCompanyProfileInvitationInput!) {
            acceptCompanyProfileInvitation(input: $input) {
                ...CompanyProfileInvitationFields
            }
        }
    `
}

export const ENABLE_COMPANY_PROFILE_INVITATION_MUTATION: GraphQL = {
    name: 'enableCompanyProfileInvitation',
    gql: gql`
        ${COMPANY_PROFILE_INVITATION_FRAGMENT}
        mutation enableCompanyProfileInvitation($profileId: Long!) {
            enableCompanyProfileInvitation(profileId: $profileId) {
                ...CompanyProfileInvitationFields
            }
        }
    `
}

export const RESEND_COMPANY_PROFILE_INVITATION_MUTATION: GraphQL = {
    name: 'resendCompanyProfileInvitation',
    gql: gql`
        mutation resendCompanyProfileInvitation($profileId: Long!) {
            resendCompanyProfileInvitation(profileId: $profileId) {
                exception
                success
            }
        }
    `
}

export const DISABLE_COMPANY_PROFILE_INVITATION_MUTATION: GraphQL = {
    name: 'disableCompanyProfileInvitation',
    gql: gql`
        ${COMPANY_PROFILE_INVITATION_FRAGMENT}
        mutation disableCompanyProfileInvitation($profileId: Long!) {
            disableCompanyProfileInvitation(profileId: $profileId) {
                ...CompanyProfileInvitationFields
            }
        }
    `
}